module.exports = __webpack_public_path__ + "img/hero_bgimage.b4bf2e88.png";